module.exports = __webpack_public_path__ + "img/KSC09679.87d2b7f2.jpg";